import jwtDecode from "jwt-decode";
import {
  GET_AUTH_URL,
  GET_AUTH_URL_DATA_RECEIVED,
  GET_AUTH_URL_ERROR
} from "../services/coreDataService";

const initialState = {
  email: undefined,
  domain: undefined,
  tid: undefined,
  authRedirectUrl: undefined,
  isLoggingIn: false,
  loggedIn: false,
  sessionJwt: undefined,
  jwtSessionEnd: undefined,
  needToUpdateServer: false,
  err: undefined,
  errorMessage: undefined,
  accountCode: "4949285"
};

// constants
const USER_LOGIN_CONTEXT_SESSION_KEY = "USER_LOGIN_CONTEXT_DATA";

// action types
export const LOAD_USER_CONTEXT = "user/LOAD_USER_CONTEXT";
export const SET_USER_ERROR_MESSAGE = "user/SET_USER_ERROR_MESSAGE";
export const CHANGE_ACCOUNT_CODE =
  "analytics/calls/summary/CHANGE_ACCOUNT_CODE";

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_ERROR_MESSAGE:
      return {
        ...state,
        err: true,
        errorMessage: action.errorMessage
      };

    case GET_AUTH_URL:
      return {
        ...state,
        isLoggingIn: true,
        email: action.username
      };

    case GET_AUTH_URL_DATA_RECEIVED:
      let tempState = {
        ...state,
        domain: action.data.domain,
        authRedirectUrl: action.data.redirectUrl,
        tid: action.data.tid
      };
      sessionStorage.setItem(
        USER_LOGIN_CONTEXT_SESSION_KEY,
        JSON.stringify(tempState)
      );
      window.location = action.data.redirectUrl;

      return {
        ...tempState
      };

    case GET_AUTH_URL_ERROR:
      return {
        ...state,
        isLoggingIn: false,
        err: action.err,
        errorMessage: action.err.message
      };

    // THAR BE DRAGONS
    // This function has side effects
    case LOAD_USER_CONTEXT:
      let restoredState = JSON.parse(
        sessionStorage.getItem(USER_LOGIN_CONTEXT_SESSION_KEY)
      );
      // Login Successful
      if (
        restoredState &&
        restoredState.isLoggingIn &&
        action.data.tid &&
        action.data.jwt
      ) {
        console.log("Login Successful.");
        let tempState = {
          ...restoredState,
          tid: action.data.tid,
          sessionJwt: action.data.jwt,
          needToUpdateServer: true,
          isLoggingIn: false,
          loggedIn: true
        };
        sessionStorage.setItem(
          USER_LOGIN_CONTEXT_SESSION_KEY,
          JSON.stringify(tempState)
        );
        return tempState;
        // login Failed
      } else if (restoredState && action.data.loginFailed) {
        console.log("Login Failed.");
        let tempState = {
          ...restoredState,
          isLoggingIn: false,
          loggedIn: false
        };
        sessionStorage.remove(USER_LOGIN_CONTEXT_SESSION_KEY);
        return tempState;
        // we were logged in and then navigated back somehow,
        // credentials could be still good, we should check
        // this with another action
      } else if (
        restoredState &&
        restoredState.sessionJwt &&
        typeof jwtDecode(restoredState.sessionJwt).exp !== undefined &&
        jwtDecode(restoredState.sessionJwt).exp > Date.now().valueOf() / 1000 &&
        !state.sessionJwt
      ) {
        console.log("Logged in, JWT not expired.");
        return restoredState;
        // otherwise we don't care, we are not logged in
      } else {
        console.log("No change.");
        return state;
      }
    case CHANGE_ACCOUNT_CODE:
      return {
        ...state,
        accountCode: action.accountCode
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/user.js